export default __webpack_public_path__ + "static/media/services6.3b869a0d.jpg";